export default __webpack_public_path__ + "static/media/marcas.fdd70f4c.png";